<template>
  <div>
    <h3>You are not authorized.</h3>
  </div>
</template>
<script></script>
<style></style>
